import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const confluent = defineConnector({
  identifier: "confluent",
  name: "Confluent Cloud",
  tagLine: "Managed Apache Kafka platform",
  logo,
  protocol: "http",
  tags: ["data", "engineering"],
  defaultUrlPattern: () => "https://api\\.confluent\\.cloud/.*",
  auth: (app) =>
    basicAuth({
      username: app.config.apiKey,
      password: app.secret.apiSecret,
    }),
  steps: [
    {
      title: "Create a Cloud API key",
      items: [
        {
          kind: "markdown",
          content:
            "Visit the [Confluent Cloud console](https://confluent.cloud/), navigate to the **API keys** section, and create a Cloud API key.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "configuration", field: "apiKey" },
        },
        {
          kind: "input",
          label: "API secret",
          required: true,
          target: { kind: "secrets", field: "apiSecret" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.confluent.cloud/org/v2/environments",
  },
});
